import { AxiosResponse } from 'axios';

import { Users } from './../pages/tech-support/Home.type';
import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessGetUsers extends ResponseREST {
	data: Array<Users>;
}

export const getUsers = async (): Promise<ResponseSuccessGetUsers> => {
	return axiosInstance
		.get('get-list-users')
		.then((res: AxiosResponse<ResponseSuccessGetUsers>) => res.data)
		.catch((err) => err);
};
